export default __webpack_public_path__ + "static/media/shapes_and_masked_images.100a6034.png";